<template>
  <div class="embed-responsive-item generic-video-js-component-player">
    <video ref="videoPlayer" playsinline class="video-js vjs-big-play-centered embed-responsive-item">
        <track 
            v-for="track in textTracks" 
            :kind="track.kind" 
            :label="track.label" 
            :src="track.src" 
            :srclang="track.srclang" 
            :key="track.id">
        </track>
    </video>
  </div>
</template>

<script>
import videojs from 'video.js';
import 'videojs-mux';
import 'videojs-markers'
import 'videojs-markers/dist/videojs.markers.css';
const VIDEOJS_MARKER_STYLE = {
    fontSize: '16px',
    fontFamily: 'Arial',
    color: '#fff',
    backgroundColor: '#fff',
    // padding: '5px 10px',
    borderRadius: '5px',
    border: '1px solid #000'
}

export default {
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        },
        chaptersVtt: {
            type: String,
            default: null,
            required: false
        },
        globalReference: {
            type: String,
            required: false
        },
        textTracks: {
            type: Array,
            default: function () {
                return []
            }
        }

    },

    data() {
        return {
            player: null,
            markers: [],
            metadataLoaded: false,
        }
    },

    methods: {
        initVideoJSMarkers () {
            this.player.markers({
                markers: this.markers,
                markerStyle: VIDEOJS_MARKER_STYLE,
                markerTip: {
                    display: true,
                    text: function(marker) {
                        return marker.text;
                    },
                    time: function(marker) {
                        return marker.time;
                    },
                },
            })

            if (this.metadataLoaded) this.player.markers.add(this.markers);
        }
    },

    mounted() {

        this.player = videojs(this.$refs.videoPlayer, this.options, function () {
            if (this.chaptersVtt) {
                this.player.addRemoteTextTrack({
                    kind: 'chapters', 
                    src: this.chaptersVtt, 
                    mode: 'showing', 
                    language: 'en',
                    default: 'default'
                })
            }
        }.bind(this))

        this.player.on("loadedmetadata", function () {
            this.metadataLoaded = true;
        }.bind(this))
        
        this.player.textTracks().addEventListener('addtrack', (event) => {
            // listen for the track's cues to finish loading
            if (event.track.kind == 'chapters') {
                event.track.on('loadeddata', () => {
                    window.track = event.track
                    var markers 
                    this.markers = track.cues_.map((cue) => {
                        return {
                            time: cue.startTime,
                            text: cue.text
                        }
                    })
                    this.initVideoJSMarkers()
                })
            }
        })

        if (this.globalReference) {
            window[this.globalReference] = this.player
        }

    },

    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    },

}
</script>

<style>
.vjs-tip {
    padding-bottom: 40px;
}
</style>

